import { create } from "zustand";
import { persist } from "zustand/middleware";
import userHooks from "../hooks/userHooks";

const useAuthStore = create(
  persist(
    (set, get) => ({
      isAuthenticated: false,
      userInfo: null,

      setAuth: (userInfo) => {
        set({
          isAuthenticated: true,
          userInfo,
        });
      },

      updateUserInfo: (userInfo) => {
        const currentState = get();
        const newState = {
          isAuthenticated: currentState.isAuthenticated,
          userInfo: {
            ...currentState.userInfo,
            ...userInfo,
          },
        };

        const storageData = {
          state: newState,
          version: 0,
        };
        localStorage.setItem(
          "dplanit-moming-auth-storage",
          JSON.stringify(storageData)
        );

        set(newState);
      },

      login: async (loginData) => {
        try {
          const response = await userHooks.signinHooks(loginData);

          if (response.IsError) {
            throw new Error("로그인 실패");
          }

          const userInfo = {
            status: true,
            ...response,
          };

          const newState = {
            isAuthenticated: true,
            userInfo,
          };

          const storageData = {
            state: newState,
            version: 0,
          };

          localStorage.setItem(
            "dplanit-moming-auth-storage",
            JSON.stringify(storageData)
          );

          set(newState);

          return { success: true, userInfo: userInfo };
        } catch (error) {
          console.error("Login error:", error);
          return { success: false, error: error.message };
        }
      },

      logout: async () => {
        try {
          const state = get();
          if (state.userInfo?.accessToken) {
            await userHooks.logoutHooks(state.userInfo?.accessToken);
            console.log("서버 로그아웃 성공");
          }
        } catch (error) {
          console.warn("서버 로그아웃 실패 (무시하고 진행):", error);
        }
      
        const newState = {
          isAuthenticated: false,
          userInfo: null,
        };
      
        const storageData = {
          state: newState,
          version: 0,
        };
        
        localStorage.setItem(
          "dplanit-moming-auth-storage",
          JSON.stringify(storageData)
        );
            
        set(newState);
      },

      updateMessageAllow: async (messageAllow) => {
        try {
          const state = get();

          if (!state.userInfo?.accessToken) {
            console.error("인증 토큰 없음");
            throw new Error("인증이 필요합니다.");
          }

          const response = await userHooks.updateMessageAllowHooks({
            messageAllow,
          });

          if (response.IsError) {
            console.error("알림톡 설정 업데이트 실패");
            throw new Error("알림톡 설정 업데이트 실패");
          }

          const newState = {
            isAuthenticated: state.isAuthenticated,
            userInfo: {
              ...state.userInfo,
              message_allow: messageAllow,
            },
          };

          const storageData = {
            state: newState,
            version: 0,
          };
          localStorage.setItem(
            "dplanit-moming-auth-storage",
            JSON.stringify(storageData)
          );

          // Zustand 상태 업데이트
          set(newState);

          return { success: true };
        } catch (error) {
          console.error("알림톡 설정 업데이트 에러:", error);
          return { success: false, error: error.message };
        }
      },

      reissueToken: async () => {
        try {
          const state = get();
          if (!state.userInfo?.refreshToken) {
            throw new Error("리프레시 토큰이 없습니다.");
          }

          const response = await userHooks.reissueAccessTokenHooks(
            state.userInfo.refreshToken
          );
          if (response.IsError) {
            throw new Error("토큰 재발급 실패");
          }

          const newState = {
            isAuthenticated: state.isAuthenticated,
            userInfo: {
              ...state.userInfo,
              accessToken: response.access_token,
              refreshToken: response.refresh_token,
            },
          };

          const storageData = {
            state: newState,
            version: 0,
          };
          localStorage.setItem(
            "dplanit-moming-auth-storage",
            JSON.stringify(storageData)
          );

          set(newState);

          return { success: true };
        } catch (error) {
          console.error("Token reissue error:", error);
          return { success: false, error: error.message };
        }
      },
    }),
    {
      name: "dplanit-moming-auth-storage",
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name);
          if (!str) return null;
          return JSON.parse(str);
        },
        setItem: (name, value) => {
          localStorage.setItem(name, JSON.stringify(value));
        },
        removeItem: (name) => {
          localStorage.removeItem(name);
        },
      },
    }
  )
);

export default useAuthStore;
